import { render, staticRenderFns } from "./CorrectorManager.vue?vue&type=template&id=fe419e76&"
import script from "./CorrectorManager.vue?vue&type=script&lang=ts&"
export * from "./CorrectorManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports